import React, { Component } from "react";
import { matchPath, withRouter } from "react-router-dom";
import { Drawer, notification } from "antd";
import Modulo from "../../GerirCursos/_Aux/Modulo";
import { GlobalContext } from "../../GlobalState";
import axios from "axios";

//const openNotificationWithIcon = (type, message, description) => {
//    notification[type]({
//        message: message,
//        description: description
//    });
//};

class OpcaoModulos extends Component {
    static contextType = GlobalContext;
    state = {
        curso: "",
        cursoid: 0,
        aulaid: 0,
        //modulos: [],
        //loading: false
    };

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        this.context.atualizarModulosEstado(false);

        this.setState({
            curso: this.props.match.params.curso,
            cursoid: localStorage.getItem("codigo_curso"),
            aulaid: localStorage.getItem("codigo_aula")
        });
    }

    //CARREGA OS MODULOS DO CURSO
    //listarModulos = () => {
    //    this.setState({
    //            loading: true
    //        });

    //    axios({
    //        method: "get",
    //        url: "/api/gestao-player/gerir-listar-modulos",
    //        params: {
    //            cursoid: localStorage.getItem("codigo_curso")
    //        }
    //    })
    //        .then(response => {
    //            this.context.atualizarState({
    //                lista_modulos: response.data
    //            });

    //            this.setState(
    //                {
    //                    modulos: response.data,
    //                    loading: false
    //                });
    //        })
    //        .catch(() => { });
    //};

    //afterVisibleChange = aberto => {
    //    if (aberto) {
    //        if (this.context.lista_modulos.length === 0) {
    //            this.setState({ loading: true })
    //            this.listarModulos();
    //        }
    //        else
    //            this.setState({
    //                modulos: this.context.lista_modulos,
    //            })
    //    }
    //    else
    //        this.setState({
    //            modulos: []
    //        })
    //}

    render() {
        const { curso, cursoid, aulaid } = this.state;
        const { modulos, loading } = this.props;

        return (
            <>
                <Drawer
                    placement="right"
                    className="drawer-modulos"
                    closable={true}
                    onClose={this.props.fecharModulos}
                    visible={this.props.drawerModulos}
                    //afterVisibleChange={this.afterVisibleChange}
                >
                    <div className="curso-modulos">
                        {loading ? (
                            <div className="loading-data">
                                <div className="loading" />
                            </div>
                        ) : (
                            modulos.map((modulo, index) => (
                                <Modulo
                                    key={index}
                                    modulo_aberto={String(this.context.moduloIndex)}
                                    collapsed={modulo.collapsed}
                                    curso={curso}
                                    cursoid={cursoid}
                                    aulaid={aulaid}
                                    index={index}
                                    modulo={modulo}
                                    player
                                    disabled={!(modulo.modulo_Aula.length > 0)}
                                    //iniciarCurso={this.iniciarCurso}
                                    //concluirDownload={this.concluirDownload}
                                    fecharModulos={this.props.fecharModulos}
                                    inscrito
                                />
                            ))
                        )}
                    </div>
                </Drawer>
            </>
        );
    }
}

export default withRouter(OpcaoModulos);
